import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ListAltIcon from '@mui/icons-material/ListAlt';

interface ManageEngagementToolbarProps {
    onNewEngagementClick: () => void;
    onShowEngagementsClick: (show: boolean) => void;
}
export default function ManageEngagementToolbar({ onNewEngagementClick, onShowEngagementsClick }: ManageEngagementToolbarProps) {
    return (
      <AppBar position='static'>
        <Toolbar>
          <Typography variant='h6' component='span'>Manage Engagements</Typography>
          <Box
            sx={{
              display: 'flex',
              columnGap: 1,
              flexGrow: 1,
              justifyContent: 'end'
            }}>
            <Button
              variant="contained"
              color='secondary'
              startIcon={<AddIcon />}
              onClick={onNewEngagementClick}
              data-cy="new-engagement-button"
            >
              New Engagement
            </Button>
            <Button
              variant="contained"
              color='secondary'
              startIcon={<ListAltIcon />}
              onClick={() => onShowEngagementsClick(true)}
              data-cy="show-engagements-button"
            >Show Engagements</Button>
          </Box>
        </Toolbar>
      </AppBar>
    );
}